import { PHONE_TEL, WHATSAPP_NUMBER, EMAIL } from "../data";

export const downloadVCard = () => {
  const vcard = [
    "BEGIN:VCARD",
    "VERSION:3.0",
    "N:Hondal López;Iván;;;",
    "FN:Iván Hondal López",
    "ORG:Ventanas Hondal",
    "TITLE:Carpintería de PVC y aluminio",
    `TEL;TYPE=CELL:+34${PHONE_TEL}`,
    `TEL;TYPE=WORK:+${WHATSAPP_NUMBER}`,
    `EMAIL:${EMAIL}`,
    "ADR;TYPE=WORK:;;Renedo de Piélagos;Cantabria;;;España",
    "NOTE:Montaje y reparación de cerramientos de PVC y aluminio en Cantabria.",
    "END:VCARD",
  ].join("\n");

  const blob = new Blob([vcard], { type: "text/vcard;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "Ventanas-Hondal.vcf";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
